import { AuthServiceProviderV1 } from '@volkswagen-onehub/authservice/dist/v1/AuthServiceProviderV1';
import { IAuthServiceV1 } from '@volkswagen-onehub/authservice/dist/v1/AuthServiceV1';
import { ServiceConfigProviderV1 } from '@volkswagen-onehub/service-config-provider';
import { useFeatureServices } from './use-feature-services';

export const getAuthService = (serviceConfig: ServiceConfigProviderV1, authServiceProvider:AuthServiceProviderV1 ) => {
    const endpoint = serviceConfig.configs['customer-profile']?.urlOrigin;      
    const authService: IAuthServiceV1 = authServiceProvider?.register('market');

    return authService;
};

export const useGetAuthService = () => {
    const serviceConfig = useFeatureServices()['service-config-provider'];
    const authService = useFeatureServices()['vw:authService'];

    return getAuthService(serviceConfig, authService);
};
